import { render, staticRenderFns } from "./RealtimeRuleCard.vue?vue&type=template&id=2ce8c745&scoped=true&"
import script from "./RealtimeRuleCard.vue?vue&type=script&lang=js&"
export * from "./RealtimeRuleCard.vue?vue&type=script&lang=js&"
import style0 from "./RealtimeRuleCard.vue?vue&type=style&index=0&id=2ce8c745&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce8c745",
  null
  
)

export default component.exports